import { Done, Save } from '@mui/icons-material';
import { Grow } from '@mui/material';

export const isSubmitAllDisabled = (
  selectedSnapshotId: number,
  appliedToAll: number,
  isDirty: boolean,
  isAdmin: boolean,
  isSnapshotLocked: boolean
) => {
  if (selectedSnapshotId === -1) return true;
  if (!isDirty && appliedToAll === selectedSnapshotId) return true;
  if (!isAdmin && isSnapshotLocked) return true;
  return false;
};

export const getSubmitAllIcon = (
  selectedSnapshotId: number,
  appliedToAll: number,
  isDirty: boolean,
  savingToAllSnapshots: boolean
) => {
  if ((appliedToAll !== selectedSnapshotId && !savingToAllSnapshots) || isDirty)
    return <Save />;
  return (
    <Grow in={appliedToAll === selectedSnapshotId && !savingToAllSnapshots}>
      <Done />
    </Grow>
  );
};
